<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="add-product-dialog"
  >
    <div class="form-content">
      <product-form
        ref="outform"
        @submit="submit"
      ></product-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import productForm from "@/components/authorize/product/productForm";
import { addProduct } from "@/api/authorize/product";

export default {
  name: "addProductDialog",
  components: {
    productForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新增产品'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        productName: form.productName,
        productCode: form.productCode,
        trialPeriod: form.trialPeriod === undefined || form.trialPeriod === '' ? null : Number(form.trialPeriod),
        status: form.status,
      }
      addProduct(params).then((data) => {
        if (data && data.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        } else {
          this.$message.error(data && data.msg ? data.msg : '添加失败');
        }
      }).catch(() => {})
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-product-dialog.sidebar-dialog .vs-sidebar {
    width: 600px;
  }
}

</style>
